export const styles = {
  modalContentContainer: {
    background: '#fafbfc',
  },

  contentContainer: {
    height: '100%',
  },

  containerStyles: {
    height: '100%',
  },
};
